import PropTypes from 'prop-types';
import { Box } from '@qga/roo-ui/components';
import { VoucherDisclaimer } from 'components/Disclaimers';
import LineItem from 'components/LineItem';
import * as propTypes from '../../propTypes';

const VoucherLineItem = ({ total }) => (
  <LineItem title="Voucher" totals={[total]}>
    <Box>
      Vouchers are non-refundable
      <VoucherDisclaimer.Link />
    </Box>
  </LineItem>
);

VoucherLineItem.propTypes = {
  total: propTypes.total.isRequired,
  paymentMethods: PropTypes.arrayOf(propTypes.voucherPaymentMethod).isRequired,
};

export default VoucherLineItem;
